import { useState, useEffect } from "react";
import ClientsQueries from "../../../../requests/queries/ClientsQueries";
import LoadingSpinner from "../../../common/Loading";
import ProtectedPage from "../../../common/ProtectedPage";
import ClientHeader from "../../../common/ClientHeader";
import ClientsAdressesQueries from "../../../../requests/queries/ClientsAdressesQueries";
import "./ProfilePageStyles.css";
import Sidebar from "../../../common/Sidebar";

export default function ProfilePage({ currentCommand, setCurrentCommand }) {

    const [client, setClient] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showAddAdressModal, setShowAddAdressModal] = useState(false);
    
    const fetchClient = async () => {
        try {
            setIsLoading(true);
            const res = await ClientsQueries.getClient();
            setClient(res.data);
            setError(null);
        } catch (err) {
            setError(err.message || "Error loading client");
            console.error("Erreur fetchClient:", err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchClient();
    }, []);

    const updateClientClient = async () => {
        try {
            const res = await ClientsQueries.update({ email: client.email });
            setError(null);
        } catch (err) {
            setError(err.message || "Error updating client");
            console.error("Erreur updateClientClient:", err);
        }
    }

    if(isLoading) {
        return <LoadingSpinner />;
    }

    if(error) {
        return (
            <ProtectedPage key={`profile-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
                <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                <div className="error-container">
                    <p>Error: {error}</p>
                </div>
            </ProtectedPage>
        );
    }

    return (
        <ProtectedPage key={`profile-${currentCommand?.id}`} permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
            <div className="patricians-layout">
                <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
                <div className="patricians-main-content">
                    {/* Sidebar gauche avec catégories */}
                    <Sidebar />

                    {/* Zone principale avec le contenu profile */}
                    <div className="profile-container">
                        <div className="profile-content">
                    <div className="profile-header">
                        <h1 className="profile-title">My Profile</h1>
                        <p className="profile-subtitle">Manage your personal information and addresses</p>
                    </div>

                    <div className="email-section">
                        <h2>Email</h2>
                        <div className="email-form">
                            <div className="email-input-group">
                                <label htmlFor="email">Email address</label>
                                <input 
                                    className="email-input"
                                    type="email" 
                                    id="email"
                                    value={client.email} 
                                    onChange={(e) => setClient({...client, email: e.target.value})} 
                                />
                            </div>
                            <button className="btn-update" onClick={() => updateClientClient()}>Update</button>
                        </div>
                    </div>

                    <div className="addresses-section">
                        <div className="addresses-header">
                            <h2>My Addresses</h2>
                            <button className="btn-add-address" onClick={() => setShowAddAdressModal(true)}>Add an address</button>
                        </div>
                        
                        {client.addresses && client.addresses.length > 0 ? (
                            <div className="addresses-list">
                                {client.addresses.map((address) => (
                                    <div key={address.id} className="address-card">
                                        <div className="address-field">
                                            <span className="address-field-label">Full name:</span>
                                            <span className="address-field-value">{address.first_name} {address.last_name}</span>
                                        </div>
                                        <div className="address-field">
                                            <span className="address-field-label">Street:</span>
                                            <span className="address-field-value">{address.street}</span>
                                        </div>
                                        {address.complement && (
                                            <div className="address-field">
                                                <span className="address-field-label">Complement:</span>
                                                <span className="address-field-value">{address.complement}</span>
                                            </div>
                                        )}
                                        <div className="address-field">
                                            <span className="address-field-label">City:</span>
                                            <span className="address-field-value">{address.city}</span>
                                        </div>
                                        <div className="address-field">
                                            <span className="address-field-label">Postal code:</span>
                                            <span className="address-field-value">{address.zip_code}</span>
                                        </div>
                                        <div className="address-field">
                                            <span className="address-field-label">Country:</span>
                                            <span className="address-field-value">{address.country}</span>
                                        </div>
                                        <div className="address-field">
                                            <span className="address-field-label">Number:</span>
                                            <span className="address-field-value">{address.number}</span>
                                        </div>
                                        <div className="address-date">
                                            Added on {new Date(address.created_at).toLocaleDateString('en-GB', { 
                                                year: 'numeric', 
                                                month: 'long', 
                                                day: 'numeric' 
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="empty-state">
                                <div className="empty-state-icon">📍</div>
                                <div className="empty-state-text">No address saved</div>
                            </div>
                        )}
                    </div>
                    </div>
                    {showAddAdressModal && <AddAdressModal setShowAddAdressModal={setShowAddAdressModal} fetchClient={fetchClient} />}
                    </div>
                </div>
            </div>
        </ProtectedPage>
    );
}

const AddAdressModal = ({fetchClient, setShowAddAdressModal}) => {

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(e.target.country.value === "Select a country") {
            return;
        }
        try {
            await ClientsAdressesQueries.create({
                street: e.target.street.value,
                city: e.target.city.value,
                zip_code: parseInt(e.target.zip_code.value),
                country: e.target.country.value,
                complement: e.target.complement.value,
                first_name: e.target.first_name.value,
                last_name: e.target.last_name.value,
                number: e.target.number.value,
            });
            setShowAddAdressModal(false);
            fetchClient();
        } catch (error) {
            console.error("Erreur lors de l'ajout de l'adresse:", error);
        }
    }

    return (
        <div className="modal-overlay" onClick={() => setShowAddAdressModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">Add a delivery address</h2>
                    <button className="btn-close" onClick={() => setShowAddAdressModal(false)}>×</button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="form-field">
                            <label htmlFor="street">Street *</label>
                            <input required type="text" id="street" name="street" placeholder="E.g. 123 Main Street" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="number">Number *</label>
                            <input required type="text" id="number" name="number" placeholder="E.g. 123" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="city">City *</label>
                            <input required type="text" id="city" name="city" placeholder="E.g. Paris" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="zip_code">Postal code *</label>
                            <input required type="text" id="zip_code" name="zip_code" placeholder="E.g. 75001" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="country">Country *</label>
                            <select required className="form-control" id="country" name="country">
                                <option>Select a country</option>
                                <option value="Belgique">Belgique</option>
                            </select>
                        </div>
                        <div className="form-field">
                            <label htmlFor="complement">Complement</label>
                            <input type="text" id="complement" name="complement" placeholder="E.g. Apt 4B, Building A" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="first_name">First name *</label>
                            <input required type="text" id="first_name" name="first_name" placeholder="E.g. John" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="last_name">Last name *</label>
                            <input required type="text" id="last_name" name="last_name" placeholder="E.g. Doe" />
                        </div>
                    </div>
                    <button className="btn-submit" type="submit">Add address</button>
                </form>
            </div>
        </div>
    );
}